import {Box, Button, Modal, ModalProps, Textarea, MantineColor} from "@mantine/core";
import {ReactNode, useState} from "react";
import {useTranslation} from "react-i18next";

export interface CommentModalProps extends Omit<ModalProps, "onSubmit"> {
  message?: ReactNode
  color?: MantineColor
  loading?: boolean
  onSubmit?: (comments: string | undefined) => void
}

export const CommentModal = (props: CommentModalProps) => {
  const {
    message,
    color,
    loading = false,
    onSubmit,
    title,
    ...rest
  } = props;

  const [comments, setComments] = useState<string | undefined>(undefined)

  const {t} = useTranslation(["common"]);

  return (
    <Modal {...rest} title={title ? title : t<string>("common.entity.message.modal.new.title", "New Comment")}>
      <Box>
        {message}
        <Textarea
          p="sm"
          placeholder={t<string>("common.entity.message.modal.new.placeholder", "Comments")}
          label={t("common.entity.message.modal.new.placeholder", "Comments")}
          autosize={true}
          minRows={4}
          onChange={(e) => setComments(e.currentTarget.value)}
        />
        <Button color={color} loading={loading} type="submit" mt="xl" onClick={() => {
          if (onSubmit) {
            onSubmit(comments ? comments : undefined);
          }
        }}>
          {t("common.action.submit", "Submit")}
        </Button>
      </Box>
    </Modal>
  );
};
